import general from "general";
import loginButton from "components/login.button";
import assign from "lodash/assign";

import "spin";

var ACCESS_DENIED = "Login failed. Please ensure that the email address and password is entered correctly.",
    SERVER_ERROR = "Unable to login right now. Try again later.",
    FORGOT_PASSWORD_ERROR = "Please enter the email address you signed up with.",
    FORGOT_PASSWORD_SUCCESS = "An email with a link to change your password has been sent to the address you entered.";

/**
 * Initialise login handling on the form contained within a given selector
 *
 * @param {string} [id] A valid selector that can be passed to jQuery. Optional, defaults to "#login-container".
 * @param {Object} [callbacks] An object mapping HTTP status codes to handler functions. Optional.
 * @login {Function} [login] A function called when the Sign In button is clicked. Optional.
 * @return {Array} The parent container
 */
var initializeLogin = function (id="#login--body", callbacks, loginHandler, modalMessages) {
    var loginBody = $(id),
        modalMessages = typeof modalMessages == "undefined" ? false : modalMessages,
        messageContainer = loginBody.find("#login-message"),
        emailInput = loginBody.find("#login-email-input"),
        passwordInput = loginBody.find("#login-password-input"),
        signInButton = loginBody.find("#sign-in-button"),
        signInContainer = signInButton.parent(),
        forgotPasswordLink = loginBody.find("#forgot-password-link"),
        disableLoginFunctions = function () {
            var height = signInContainer.height();
            signInButton.hide();
            signInContainer.height(height).spin();
            forgotPasswordLink.prop("disabled", true);
            $(emailInput).add(passwordInput).unbind("keypress");
        },
        enableLoginFunctions = function () {
            signInButton.show();
            signInContainer.spin(false);
            forgotPasswordLink.prop("disabled", false);
            $(emailInput).add(passwordInput).unbind("keypress").keypress(keypressHandler);
        },
        defaultCallbacks = {
            201: function (data, textStatus, jqXHR) {
                loginButton.refresh();
            },
            401: function () {
                general.endSession(function () {}); // end session without redirecting
                if (modalMessages) general.modalMessage(ACCESS_DENIED, "error");
                else messageContainer
                    .addClass("text-error")
                    .html(ACCESS_DENIED);
            },
            503: function () {
                general.endSession(function () {});
                if (modalMessages) general.modalMessage(SERVER_ERROR, "error");
                else messageContainer
                    .addClass("text-error")
                    .html(SERVER_ERROR);
            },
        },
        loginHandler = loginHandler || function (e) {
            e.preventDefault();
            e.stopPropagation();
            disableLoginFunctions();
            callbacks[401].push(enableLoginFunctions);
            general.startSession(emailInput.val().toLowerCase(), passwordInput.val(), callbacks);
            passwordInput.val("");
        },
        keypressHandler = function (e) {
            e.stopPropagation();
            var code = e.keyCode || e.which;
            if (code === 10 || code === 13) {
                loginHandler(e);
            }
        },
        forgotPasswordHandler = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!emailInput.val()) {
                if (modalMessages) general.modalMessage(FORGOT_PASSWORD_ERROR, "error");
                else messageContainer.addClass("text-error").html(FORGOT_PASSWORD_ERROR);
            } else {
                disableLoginFunctions();
                general.callApi("forgot_password/", "POST", {username: emailInput.val()}, null, function () {
                    enableLoginFunctions();
                    if (modalMessages) general.modalMessage(FORGOT_PASSWORD_SUCCESS, "info");
                    else messageContainer.removeClass("text-error").html(FORGOT_PASSWORD_SUCCESS);
                }, enableLoginFunctions);
            }
        };

    callbacks = assign({}, defaultCallbacks, callbacks || {});
    $(emailInput).add(passwordInput).unbind("keypress").keypress(keypressHandler);
    signInButton.unbind("click").click(loginHandler);
    forgotPasswordLink.unbind("click").click(forgotPasswordHandler);
    return loginBody;
};

export default initializeLogin;
